import find from 'lodash/find';
import filter from 'lodash/filter';

export default {
	translations: state => {
		return state.translations;
	},


	stations: state => {
		return state.stations;
	},
	station: state => (value, key) => {
		if(!key) key = 'station';
		return find(state.stations, [key, value]);
	},


	offers: state => {
		return state.offers;
	},
	offer: state => (value, key) => {
		if(!key) key = 'rate_pk';
		return find(state.offers, [key, value]);
	},


	groups: state => {
		return state.groups;
	},
	group: state => (value, key) => {
		if(!key) key = 'groupKey';
		return find(state.groups, [key, value]);
	},


	params: state => {
		return state.params;
	},
	param: state => (value, key) => {
		if(!key) key = 'param';
		return find(state.params, [key, value]);
	},

	salutations: state => {
		return state.salutations;
	},

	config: state => {
		return state.config;
	},

	sid: state => {
		return state.user_session;
	},

	footernavigationAll: state => {
		return state.footernavigation;
	},
	footernavigation: state => (value, key) => {
		if(!key) key = 'path';
		return find(state.footernavigation, [key, value]);
	},
	mainnavigationAll: state  => {
		return state.mainnavigation;
	},
	mainnavigation: state => (value, key) => {
		if(!key) key = 'path';
		return find(state.mainnavigation, [key, value]);
	},

	homepage: state => {
		return state.homepage;
	},
	contactpage: state => {
		return state.contactpage;
	},
	faq: state => {
		return state.faq;
	},
	headernavigation: state => {
		return state.headernavigation;
	},
};



// WEBPACK FOOTER //
// ./src/store/orm/getters.js